/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Anjana Deshan",
  title: "Hi, I'm Anjana",
  subTitle: emoji(
    "A passionate Software Developer from Sri Lanka 🚀 having an experience of building Web and Mobile applications with Java, PHP and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1a5WHEmiXLjuOfR-gOx6jjOdh7C2ZbHqQ/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/anjanadeshan",
  linkedin: "https://www.linkedin.com/in/anjana-deshan/",
  gmail: "a.deshan85@gmail.com",
  gitlab: "",
  facebook: "https://www.facebook.com/anjana.deshan",
  medium: "https://medium.com/@anjana_desh",
  stackoverflow: "",
  twitter: "https://twitter.com/anjana_desh",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Im a Tech enthusiast, i love to try new technologies and good at problem solving",
  skills: [
    emoji(
      "⚡ Develop native mobile applications"
    ),
    emoji("⚡ Progressive Web Applications "),
    emoji(
      "⚡ Desktop Applications Developing"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
	{
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
	{
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
	{
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
	{
      skillName: "Codeigniter",
      fontAwesomeClassname: "fab fa-gripfire"
    },
	{
      skillName: "Wordpress",
      fontAwesomeClassname: "fab fa-wordpress"
    },
	{
      skillName: "Bootsrtap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
	{
      skillName: "Oracle Cloud",
      fontAwesomeClassname: "fas fa-cloud"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "VTA Sri lanka",
      logo: require("./assets/images/vta.jpeg"),
      subHeader: "Software Developer",
      duration: "September 2018 - 2019",
      desc: "Completed  1 Year NVQ L4 full-time Certification"
    },
    {
      schoolName: "Dharmapala College - Katukurunda",
      logo: require("./assets/images/school.jpg"),
      subHeader: "Successfully Completed High School",
      duration: "2014 - 2016",
      desc: "",
      descBullets: ["General Certificate of Education (G.C.E) Advanced level in Technology Stream. (2016)"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience:[
    {
      role: "Software Engineer",
      company: "Helios Ventures (Pvt) Ltd",
      companylogo: require("./assets/images/hv.png"),
      date: "2022 Feb – Present",
      desc: "Helios Ventures  global group's core business is in the financial services sector and plans to grow via both organic growth and merger & acquisition of financial services companies globally .",
      descBullets: [
        "Involved in major Development"
      ]
    },
    {
      role: "Associate Software Engineer",
      company: "Bitzean",
      companylogo: require("./assets/images/bz.png"),
      date: "2020 – 2022 Feb",
      desc: "Bitzean is Social media platform with some other services such as Advertisement and Freelance",
      descBullets: [
        "Involved in major Developmet",
		"Became a member of mobile development team",
        "Contribute to main android application development"
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "SciMind AB",
      companylogo: require("./assets/images/scimind.png"),
      date: "June 2019 – Dec 2019",
      desc: "SciPro+ is an online ICT support system for management and supervision of thesis",
	     descBullets: [
        "learn basics of React Js",
		"Developed UI Designs"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/bz.png"),
      projectName: "Bitzean Advertisement",
      projectDesc: "Bitzean Advertisement is a classified advertisements website",
      footerLink: [
      
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/app.png"),
      projectName: "Bitzean Android App",
      projectDesc: "Social Media + Advertisement Platfoarm",
      footerLink: [
        {
          name: "App",
          url: "https://play.google.com/store/apps/details?id=com.bitzean.social&hl=en&gl=US"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "a.deshan85@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "anjana_desh", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
